import HousingProductType from "constants/housingProductType";
import SpecCard from "../models/specCard";
import PlanCard from "../models/planCard";
import CommunityCard from "../models/communityCard";
import BasicListingCard from "../models/basicListing";

const housingCardConstructor = new Map();

housingCardConstructor.set(HousingProductType.Spec().getName(), SpecCard);
housingCardConstructor.set(HousingProductType.Plan().getName(), PlanCard);
housingCardConstructor.set(HousingProductType.Community().getName(), CommunityCard);
housingCardConstructor.set(HousingProductType.BasicListing().getName(), BasicListingCard);

/**
 * Returns the class constructor with the listing information according to the type.
 *
 * @param type - The type of listing (Spec, plan, community).
 * @param url - The listing URL.
 * @param listingInformation - The listing (Spec, plan, community) information.
 */
export default (type, url, listingInformation) => {
    const generator = housingCardConstructor.get(type);
  
    if (!generator) {
      return null;
    }
  
    return new generator.prototype.constructor(url, listingInformation);
  };
  